 
import moment from 'lib/moment-timezone-custom'
import Resource from './resource'
import ky from 'lib/ky'

export default class Game extends Resource {
  async cancel () {
    return new this.constructor({
      attrs: await ky.put(`${this.resourcePath}/cancel.json`).json(), root: this.root
    })
  }

  isMinimalDataSetPresent () {
    return this.reservedTo && this.room && typeof this.playersCount === 'number'
  }

  set reservedTo (value) {
    if (typeof value === 'string') {
      this.data.reservedTo = moment.parseZone(value)
    } else {
      this.data.reservedTo = value
    }
  }

  set runningFrom (value) {
    if (typeof value === 'string') {
      this.data.runningFrom = moment.parseZone(value)
    } else {
      this.data.runningFrom = value
    }
  }

  get asJson () {
    const json = super.asJson
    json.roomId = json.room?.id || json.roomId
    delete json.room
    if (json.reservedTo !== undefined) json.reservedTo = json.reservedTo.toISOString()
    return json
  }

  asConversion () {
    return {
      item_id: this.room?.friendlyId,
      item_name: this.name,
      coupon: this.giftCardString || this.promoCodeString,
      discount: this.regularCost - this.endCost,
      item_brand: '60out',
      item_category: this.room?.genre,
      item_category2: this.room?.interactionType,
      item_variant: this.pricingTier,
      location_id: this.location?.friendlyId,
      price: this.regularCost,
      quantity: 1
    }
  }
}

Game.paramName = 'game'
